import Constants from 'expo-constants';

/**
 * Version Constants
 *
 * Centralized version information for the application.
 * Both app version and OTA version are defined in app.json and passed through app.config.js
 *
 * SINGLE SOURCE OF TRUTH: app.json
 * - version: "1.0.3" (app store version)
 * - otaVersion: "250705" (OTA deployment version)
 *
 * This version is used in:
 * - Display version in Wrapper.js
 * - API query parameter 'v' for device config, booking list, and maintenance requests
 * - User-Agent header in API requests
 * - Redux store initialization
 */

// Get both app version and OTA version from app.json via app.config.js
export const APP_VERSION = Constants.expoConfig?.extra?.appVersion || '1.0.3';
export const OTA_VERSION = Constants.expoConfig?.extra?.otaVersion || '250705';

// Combined version for API query parameter (URL-safe with underscore)
export const API_VERSION = `${APP_VERSION}_${OTA_VERSION}`;

// For display (with 'v' prefix) - formatted as v{app_version}({ota_version})
export const DISPLAY_VERSION = `v${APP_VERSION}(${OTA_VERSION})`;
